/**
 * Centralized display formatting for event types coming from API/constants.
 * We keep the raw values intact for matching/slugs, and only format at render-time.
 */
export function toEventTypeDisplayLabel(raw: string | null | undefined): string {
  const value = (raw ?? '').toString().trim();
  if (!value) return '';

  // Fix common pluralization used in data.
  // Example: "Birthday Parties" -> "Birthday Party"
  if (/\bparties\b/i.test(value)) {
    return value.replace(/\bparties\b/gi, 'Party');
  }

  return value;
}

